(function ($) {
    $(document).ready(function () {
        $('.content-image-slider .img-box .img-box-slider').slick({
            //centerMode: true,

            slidesToShow: 1,
            infinite: true,
            dots: true,
            dotsClass: 'custom-dots',
            arrows: false,
            speed: 700,
            fade: true,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: 'ease',
            pauseOnHover: false,
            responsive: []
        });

    });
})(jQuery);